export const SIMPLE_PICKER_FILTER_TYPES = new Set([
  'cidade',
  'retorno',
  'sla',
  'tipoOS',
  'status',
  'equipamento',
  'tecnicoInicial',
  'bairro',
  'cliente',
  'defeitoDescricao',
  'defeitoAlert',
  'defeitoClassification',
  'defeitoSeverity',
  'previsao',
]);

export const SIMPLE_PICKER_BULK_MENU_TYPES = new Set([
  'retorno',
  'equipamento',
  'cliente',
  'bairro',
  'defeitoDescricao',
  'defeitoAlert',
]);

export function isSimplePickerFilterType(filterType) {
  return SIMPLE_PICKER_FILTER_TYPES.has(filterType);
}
